import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { Editor } from 'slate';
import { ReactEditor, useSlateStatic } from 'slate-react';

import { Separator } from '../../../../../Layout/Landing/Content/Separator';
import { clearTextByElementId } from '../../../shared-transforms';
import { useCardLogicStore } from '../../model/card-logic.store';
import { CardLogicTransformActions } from '../../model/transforms';
import { MenuItem, MenuMain } from '../Header/CardLogicHeaderPopoverMenu';

interface CardLogicCellPopoverMenuProps {
  element: any;
}

export const CardLogicCellPopoverMenu = observer((props: CardLogicCellPopoverMenuProps) => {
  const { element } = props;
  const editor = useSlateStatic();
  const cardLogicStore = useCardLogicStore();

  const path = ReactEditor.findPath(editor as any, element);
  const [parentNode] = Editor.parent(editor, path);
  const canDeleteCell = parentNode.children.length > 2;

  return (
    <MenuMain className="header-menu">
      <div className="menu">
        <MenuItem
          isActive={element.textAlign === 'left'}
          onMouseDown={() => {
            CardLogicTransformActions.setNodesByElementId({
              editor,
              value: {
                textAlign: 'left',
              },
              elementId: element.id,
            });
          }}
        >
          Align Left
        </MenuItem>
        <MenuItem
          isActive={element.textAlign === 'center'}
          onMouseDown={() => {
            CardLogicTransformActions.setNodesByElementId({
              editor,
              value: {
                textAlign: 'center',
              },
              elementId: element.id,
            });
          }}
        >
          Align Middle
        </MenuItem>
        <MenuItem
          isActive={element.textAlign === 'right'}
          onMouseDown={() => {
            CardLogicTransformActions.setNodesByElementId({
              editor,
              value: {
                textAlign: 'right',
              },
              elementId: element.id,
            });
          }}
        >
          Align Right
        </MenuItem>

        <Separator backgroundColor="black10" variant="horizontal" />
        <MenuItem
          onMouseDown={() => {
            clearTextByElementId({
              editor,
              elementId: element.id,
            });
          }}
        >
          Clear Content
        </MenuItem>
        <MenuItem
          onMouseDown={() =>
            cardLogicStore.addCardBefore({
              editor,
              elementId: element.id,
            })
          }
        >
          Add Card Before
        </MenuItem>
        <MenuItem
          onMouseDown={() =>
            cardLogicStore.addCardAfter({
              editor,
              elementId: element.id,
            })
          }
        >
          Add Card After
        </MenuItem>
        <MenuItem
          disabled={!canDeleteCell}
          onMouseDown={() => {
            cardLogicStore.removeCard({
              editor,
              elementId: element.id,
            });
          }}
        >
          Remove Card
        </MenuItem>
      </div>
    </MenuMain>
  );
});
